// AI-CONTEXT: See docs/features/role-based-permissions.md
//
// Combines registered team members with pending invitations into a single
// list for the Team table. Each row carries a `_type` ('member' | 'invite')
// so the renderer can branch. A pending invite is dropped once a member with
// the same email exists (the invite is normally deleted on registration, but
// this guards the brief window before that happens). Soft-deleted invites
// (Deleted flag, ADR-008) are excluded.

import normalizeEmail from './normalizeEmail'

const mergeTeamRows = (members, invites) => {
    const memberList = Array.isArray(members) ? members : []
    const inviteList = Array.isArray(invites) ? invites : []

    const memberEmails = new Set(memberList.map((m) => normalizeEmail(m.Email)))

    const memberRows = memberList.map((m) => ({ ...m, _type: 'member' }))
    const inviteRows = inviteList
        .filter((i) => !i.Deleted)
        .filter((i) => !memberEmails.has(normalizeEmail(i.Email)))
        .map((i) => ({ ...i, _type: 'invite' }))

    return [...memberRows, ...inviteRows]
}

export default mergeTeamRows
